import React from 'react';
import styled from 'styled-components';
import { CloudDownloadOutlined } from '@ant-design/icons';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


import '../assets/accordion.css';

import HitTool from '../components/hitTool.js';
import Reference from '../components/reference.js';

function HybridIonTreatment() {

	const clipBoardText = "Sun, S., Karki, C., Xie, Y., Xian, Y., Guo, W., Gao, B. Z., & Li, L. (2021). Hybrid method for representing ions in implicit solvation calculations. Computational and structural biotechnology journal, 19, 801-811.";

  return (
    <div class="inner-section">
    <div class="container">
        <h3 class="header-title">Hybrid Ions Treatment</h3>
				<Accordion preExpanded={['a']}>
            <AccordionItem uuid="a">
                <AccordionItemHeading>
                    <AccordionItemButton>
                        Hybrid Ions Treatment
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <HitTool/>
                </AccordionItemPanel>
            </AccordionItem>


        </Accordion>

				<RefContactContainer>

					<ReferenceContainer>
						<h6>We humbly ask to cite this reference if your results from this web server are used in publications:</h6>
						<Reference title="HIT" clipBoardText={clipBoardText} publicationLink="https://www.sciencedirect.com/science/article/pii/S2001037021000246" />

					</ReferenceContainer>
					<ContactContainer>
						<Contact><b>Contact:</b> lli5@utep.edu</Contact>
						<A href="/software"> <CloudDownloadOutlined style={{ fontSize: '33px' }} />
						 Download tools
						 </A>
					</ContactContainer>

				</RefContactContainer>


		 </div>

    </div>




  );
}


const Contact = styled.p`
    margin-top: 22px;
`;

const RefContactContainer = styled.div`
	display:flex;
	flex-direction: column;
  justify-content: space-between;
  align-items: center;
	margin-top:45px;
`;

const ContactContainer = styled.div`
	display: flex;
	flex-direction:row;
	font-family:"Fira Sans";
	justify-content:space-between;
	width: 100%;
	align-items:center;
`;

const ReferenceContainer = styled.div`
	display:flex;
	flex-direction:column;
`;

const A = styled.a`
	display:flex;
  flex-direction: column;
`;







export default HybridIonTreatment;



// WEBPACK FOOTER //
// ./src/pages/hybridIonTreatment.js